import React from 'react';
import type { Pageable } from '../common/Pager/types';
import Pager from '../common/Pager/Pager';
import { PagerPosition, PagerVariant } from '../common/Pager/enums';
import { useClassNameMapper } from 'react-bootstrap';
import { KeyBoardEvents } from '@aurora/shared-types/community/enums';

interface Props extends Pageable {
  /** Class name(s) to apply to the {@link Pager} component */
  className: string;
}

/**
 * A pager pre-customized for usage in AdvancedDropdown
 * @author Akash Goenka, Rosalyn Rowe
 */
const AdvancedDropdownPager: React.FC<Props> = ({ className, pageInfo, loadPage }) => {
  const cx = useClassNameMapper();

  return (
    <div
      role="none"
      onKeyDown={event => {
        if (event.key === KeyBoardEvents.ARROW_DOWN) {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
    >
      <Pager
        className={cx(className)}
        variant={{
          type: PagerVariant.LOAD_MORE,
          props: {
            clearLoadingAfterUpdate: true,
            position: PagerPosition.START
          }
        }}
        pageInfo={pageInfo}
        loadPage={loadPage}
      />
    </div>
  );
};

export default AdvancedDropdownPager;
